__turbopack_context__.v({
  "borderColor--warning": "rAwkiq_borderColor--warning",
  "check": "rAwkiq_check",
  "checkbox": "rAwkiq_checkbox",
  "container": "rAwkiq_container",
  "count": "rAwkiq_count",
  "iconCheck": "rAwkiq_iconCheck",
  "label": "rAwkiq_label",
  "selected": "rAwkiq_selected",
  "size--lg": "rAwkiq_size--lg",
  "size--sm": "rAwkiq_size--sm",
  "variant--simple": "rAwkiq_variant--simple",
  "variant--stacked": "rAwkiq_variant--stacked",
  "wiggle--a": "rAwkiq_wiggle--a",
  "wiggle--b": "rAwkiq_wiggle--b",
  "wrap": "rAwkiq_wrap",
});
